import React from 'react'

import { memo } from 'react'

import { IoWarningOutline } from 'react-icons/io5'

import { date_validations as validations } from './maskValidations'

export default memo(function DateVisualHelper ({ ...props })
{
	let is__valid = true;

	const infos = getExplodedValidation(props.user_value, props.mask);

	const letters = Array.from(props.mask).map(function (letter, i)
	{
		let class_name = props.className + '__letter';

		if (infos[i] === true)
		{
			class_name += ' is-valid';
		}
		else if (infos[i] === false)
		{
			class_name += ' is-invalid';
			is__valid = false;
		}

		return (
			// eslint-disable-next-line react/no-array-index-key
			<span key={ 'i-' + i + '-l-' + letter }
				className={ class_name }
				aria-hidden={ props.hide > i }>
				{ letter }
			</span>
		);
	});

	let class_name = props.className || '';

	const Icon = props.invalid || !is__valid
	? IoWarningOutline
	: undefined;

	if (props.incomplete) class_name += ' is-incomplete';
	if (props.invalid || !is__valid) class_name += ' is-invalid';

	if (props.user_value?.length > 0) class_name += ' is-visible';

	return (
		<div className={ class_name + ' u-no-select' } aria-hidden="true">
			{ letters }

			{
				Icon
				? <Icon className={ (props.className || '') + '-icon' } />
				: undefined
			}
		</div>
	);
});

let mask_numbers_chars =
[
	'd', 'm', 'y', 'h', 's'
];

mask_numbers_chars = mask_numbers_chars
.concat(mask_numbers_chars.map(c => c.toUpperCase()));

function getExplodedValidation (value, mask)
{
	return Array.from(mask).slice(0, (value || '').length)
	.reduce(function (exploded, char, i)
	{
		if (mask_numbers_chars.includes(char) === false)
		{
			return { ...exploded, [i]: value[i] === char };
		}

		const isValid = validations[mask] || validations['DD/MM/YYYY'];

		exploded[i] = isValid(value, i);

		return exploded;
	},
	{ });
}

